import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
  BODY_TRANSFORMER_ITEMS_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.Collapse,
  configGroups: [
    {
      title: 'Component Properties',
      items: [
        {
          name: 'accordion',
          label: 'Accordion (only one panel open at a time)',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
          ],
        },
        {
          name: 'bordered',
          label: 'Bordered',
          valueComponent: {
            type: 'Switch',
            defaultValue: true,
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
          ],
        },
        {
          name: 'size',
          label: 'Size',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Small', value: 'small' },
              { label: 'Middle', value: 'middle' },
              { label: 'Large', value: 'large' },
            ],
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Dynamic Items',
      items: [
        {
          name: 'items',
          label: 'Items Source (JMESPath)',
          valueComponent: {
            type: 'CodeEditor',
            placeholder: 'e.g., @.sudCases[]',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.Variable,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BODY_TRANSFORMER_ITEMS_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
          ],
        },
        {
          name: 'itemLabelPath',
          label: 'Panel Label Path (JMESPath, relative to item)',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g., code',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'itemKeyPath',
          label: 'Panel Key Path (JMESPath, relative to item)',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g., id (defaults to item index)',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'itemName',
          label: 'Item Name',
          valueComponent: {
            type: 'Input',
            placeholder: 'e.g., item',
            defaultValue: 'item',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Collapse Panels',
      component: 'CollapsePanelsConfigPanel',
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
